import React from "react";
import Face from "./Face";
import Quote from "./Quote";
import { Link } from "react-router-dom";
import "tachyons";
import "./Home.css";

const Home = () => {
    return (
        <div className="home">
            <div id="home_face"><Face /></div>
            <div id="home_quote" className="pa2"><Quote />
                <div className="flex items-center justify-center" id="home_buttons">
                    <Link
                        exact
                        to="/contact"
                        className="f4 no-underline black-80 bg-black-80 bg-animate hover-bg-black hover-white inline-flex items-center pa3 ph4 ba border-box mr2"
                    >
                        <span className="pl1 white ph2">HIRE ME</span>
                    </Link>
                    <Link
                        exact
                        to="/about"
                        className="f4 no-underline black bg-animate hover-bg-black hover-white inline-flex items-center pa3 ba border-box"
                    >
                        <span className="pr1 ph2">EXPLORE MORE</span>
                        <svg
                            className="w1"
                            data-icon="chevronRight"
                            viewBox="0 0 32 32"
                            style={{ fill: "currentcolor" }}
                        >
                            <title>chevronRight icon</title>
                            <path d="M12 1 L26 16 L12 31 L8 27 L18 16 L8 5 z"></path>
                        </svg>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default Home;
